export type RegistrationStatus =
  | 'profile_pending'
  | 'accommodation_pending'
  | 'approval_pending'
  | 'approved';

export type UserRole = 'socio' | 'manager' | 'ventas' | 'colaborador';

export interface UserStatus {
  role: UserRole;
  registrationStatus: RegistrationStatus;
  email: string;
  displayName: string;
  createdAt?: unknown;
  /** SIP username that identifies a "ventas" user on recorded calls. */
  sipUsername?: string | null;
  /** SIP password from Twilio, served in the Linphone provisioning XML. */
  sipPassword?: string | null;
  /**
   * Hotel al que pertenece un colaborador. Solo para `role: 'colaborador'`;
   * lo escribe `POST /api/collaborators/accept-invite`.
   */
  employerUid?: string;
  /** Alojamiento del empleador, snapshoteado al aceptar la invitación. */
  employerAccommodationId?: string;
  /** Documento `collaborators/{id}` que originó esta cuenta. */
  collaboratorId?: string;
}

/** Effective status computed from Firestore + Auth.emailVerified */
export type EffectiveStatus =
  | 'email_unverified'
  | 'profile_pending'
  | 'accommodation_pending'
  | 'approval_pending'
  | 'approved';

export function computeEffectiveStatus(
  registrationStatus: RegistrationStatus,
  emailVerified: boolean,
): EffectiveStatus {
  if (registrationStatus === 'profile_pending' && !emailVerified) {
    return 'email_unverified';
  }
  return registrationStatus;
}
